module.exports = __webpack_public_path__ + "img/taoyuan-1.7c2588b0.jpg";